module.exports = __webpack_public_path__ + "static/media/m5.db2c8b7d.png";